var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticStyle:{"width":"140px"},attrs:{"disabled":_vm.disabled,"type":"tel","placeholder":"vd: 28/04/1999"}})}
var staticRenderFns = []

export { render, staticRenderFns }